export const GETSTREAM_KEY = 'rvnedj8krevj'
export const BASE_URL = 'https://api.plthub.app:5002'
export const MY_MACROS_API_KEY = 'yooqLbJ7jKdGYcMLZ3c900UnigxNVyYo'
